import {
  AiInstructionsTranscriptComponent,
  TranscriptComponent,
} from './types';

export const KC_GROUP_MIN_INSTRUCTIONS = 2;

export type SingleBlock = {
  component: TranscriptComponent;
  index: number;
  type: 'single';
};

export type KcGroupBlock = {
  components: NonEmptyArray<AiInstructionsTranscriptComponent>;
  startIndex: number;
  type: 'kc-group';
};

export type RenderBlock = SingleBlock | KcGroupBlock;

export type NonEmptyArray<T> = readonly [T, ...T[]];

export const buildRenderBlocks = (
  transcriptComponents: TranscriptComponent[],
): RenderBlock[] => {
  const blocks: RenderBlock[] = [];
  let i = 0;
  while (i < transcriptComponents.length) {
    const comp = transcriptComponents[i];
    if (comp.message_type !== 'ai_instructions') {
      blocks.push({ component: comp, index: i, type: 'single' });
      i++;
      continue;
    }

    const runStart = i;
    const runComponents: AiInstructionsTranscriptComponent[] = [];
    while (
      i < transcriptComponents.length &&
      transcriptComponents[i].message_type === 'ai_instructions'
    ) {
      runComponents.push(
        transcriptComponents[i] as AiInstructionsTranscriptComponent,
      );
      i++;
    }

    const totalIds = runComponents.reduce(
      (sum, c) => sum + c.ai_instruction_ids.length,
      0,
    );

    if (totalIds >= KC_GROUP_MIN_INSTRUCTIONS && runComponents.length > 0) {
      blocks.push({
        components:
          runComponents as unknown as NonEmptyArray<AiInstructionsTranscriptComponent>,
        startIndex: runStart,
        type: 'kc-group',
      });
    } else {
      runComponents.forEach((c, offset) => {
        blocks.push({
          component: c,
          index: runStart + offset,
          type: 'single',
        });
      });
    }
  }
  return blocks;
};
